import { axios } from '../../../../services/axios';
import * as CONST from '../../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.COMPLAINT_ACTION_CREATE_SUCCESS, complaint: data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.COMPLAINT_ACTION_CREATE_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const complaintActionAdd = (data, complaintId) => {
  return async (dispatch) => {
    dispatch({ type: CONST.COMPLAINT_ACTION_CREATE_REQUEST });

    axios.put(`/tickets/${complaintId}`, data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
